import * as yup from 'yup';

import { WorkloadResourceLimitTypeFormModel } from '../../../_types';

const multiplierField = yup
  .number()
  .nullable()
  .required()
  .when('type', {
    is: (type: WorkloadResourceLimitTypeFormModel) => type === 'MULTIPLIER',
    then: (schema) => schema.required('Multiplier is required.'),
    otherwise: (schema) => schema.nullable(),
  });

export const resourceLimitsValidationSchema = yup.object({
  cpu: yup
    .object({
      type: yup
        .mixed<WorkloadResourceLimitTypeFormModel>()
        .oneOf([
          'MULTIPLIER',
          'NO_LIMIT',
          'AUTO',
          'KEEP_LIMITS',
          'MAINTAIN_RATIO',
          'SEMI_AUTOMATIC',
        ])
        .required(),
      multiplier: multiplierField,
      semiAutoMultiplier: yup
        .number()
        .nullable()
        .required()
        .when('type', {
          is: (type: WorkloadResourceLimitTypeFormModel) =>
            type === 'SEMI_AUTOMATIC',
          then: (schema) => schema.required('Multiplier is required.'),
          otherwise: (schema) => schema.nullable(),
        }),
    })
    .required(),
  memory: yup
    .object({
      type: yup
        .mixed<WorkloadResourceLimitTypeFormModel>()
        .oneOf([
          'MULTIPLIER',
          'NO_LIMIT',
          'AUTO',
          'KEEP_LIMITS',
          'MAINTAIN_RATIO',
        ])
        .required(),
      multiplier: multiplierField,
      semiAutoMultiplier: yup.number().required().nullable(),
    })
    .required(),
});
